import { useIsLogged } from "../../../hooks/auth/use-is-logged/use-is-logged";
import { BONUSX_SUBSCRIPTION_TIERS } from "../../../legacy/services/user-subscription/enums/bonusx-subscription-tiers.enum";
import { useUserSubscriptionAccountQuery } from "./useUserSubscriptionAccount.query";

export interface IUseUserSubscriptionTierQuery {
  currentUserTier: BONUSX_SUBSCRIPTION_TIERS;
  isLoading: boolean;
  error: Error | undefined;
}

export function useUserSubscriptionTierQuery(): IUseUserSubscriptionTierQuery {
  const isLogged = useIsLogged();
  const { account, isLoading, error } = useUserSubscriptionAccountQuery();

  const currentUserTier = isLogged
    ? (account?.subscriptionTier as BONUSX_SUBSCRIPTION_TIERS) ?? BONUSX_SUBSCRIPTION_TIERS.FREE
    : BONUSX_SUBSCRIPTION_TIERS.FREE;

  const isInitialLoading = isLoading && account === undefined;

  return {
    currentUserTier,
    isLoading: isInitialLoading,
    error,
  };
}
